// extracted by mini-css-extract-plugin
export default {"button":"buttonSubmit_button__QsqDR","button_disabled":"buttonSubmit_button_disabled__UDjLd"};